var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updateTime)?_c('div',{staticClass:"UpdateTime"},[_vm._v(" Updated: "+_vm._s(_vm.updateTime)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }